import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material';
import { environment } from 'src/environments/environment.test';
import { Utils } from 'src/app/Utils';
import { ExternalRouterService } from 'src/app/services/external-router.service';
import { CookieService } from 'ngx-cookie-service';
import { Cart } from 'src/app/models/cart';
import { GetCartService } from 'src/app/services/cart/get-cart.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CartItemsService } from 'src/app/services/cart-items.service';
import { SharingService } from 'src/app/services/sharing.service';
import { AuthService } from 'src/app/services/auth.service';
import { GetProductService } from 'src/app/services/product/get-product.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-gps-protection',
  templateUrl: './gps-protection.component.html',
  styleUrls: ['./gps-protection.component.scss']
})
export class GpsProtectionComponent implements OnInit {

  constructor(private bottomSheetRef: MatBottomSheetRef<GpsProtectionComponent>,@Inject(MAT_BOTTOM_SHEET_DATA) public data: { name: string },
private externalRouter: ExternalRouterService,
private getCartService: GetCartService,
private cartItemService: CartItemsService,
private cartItemsService: CartItemsService,
private sharingService: SharingService,
private authService: AuthService,
private cookieService: CookieService,
 private getProductService: GetProductService,
 private cartService: GetCartService,
 private cdr: ChangeDetectorRef,
public _cookie: CookieService,)
 { 
    console.log("🚨 Product name from bottom sheet:", data.name);
  }
  cart;
  postCart = new Cart();
loaded3=true;
productQuantities: { [key: string]: number } = {};
cartItems = 0;
mrp: number;
discount: number;
total = 0;
addedProtectionCover: boolean = false;

  ngOnInit() {
    // this.loadCart();
  }
  close(): void {
    this.bottomSheetRef.dismiss();
  }

  // loadCart() {
  //   const cartId = this._cookie.get('cartId'); // Get cartId from cookies
  //    // Start shimmer effect
  //   this.loaded3 = false;

  //   if (!cartId) {
  //     // No cart found, reset cart state
  //     this.cart = { products: [] };
  //     this.cartItems = 0;
  //     this.productQuantities = {};
  //     //   if (this.router.url === '/gps-tracking-devices/ol_vidsure' && window.innerWidth < 768) {
  //     //   setTimeout(() => {
  //     //     // console.log("✅ Calling changeUniqueVariant() after cart update...");
  //     //     this.changeUniqueVariant();
  //     // }, 1000); 
  //     // }
     
  //     this.loaded3 = true;

  //     return;
  //   }

  //   this.cartService.getCart().subscribe(
  //     (cartData) => {
  //       this.cart = cartData.body || { products: [] };

  //       // Calculate total quantity of all products in the cart
  //       this.cartItems = this.cart.products.reduce((total, product) => total + product.quantity, 0);
  //       this.cartService.updateCartItems(this.cartItems);

  //       this.productQuantities = this.cart.products.reduce((quantities, product) => {
  //         if (product && product.product && product.product.productId) {
  //           quantities[product.product.productId] = product.quantity;
  //         } else {
  //           console.warn("⚠️ Missing product or productId for:", product);
  //         }
  //         return quantities;
  //       }, {});

       
  //       this.loaded3 = true; // Data has loaded

  //       // ✅ Ensure `changeUniqueVariant()` runs last after cart update
  //       // if (this.router.url === '/gps-tracking-devices/ol_vidsure' && window.innerWidth < 768) {
  //       //   setTimeout(() => {
  //       //     // console.log("✅ Calling changeUniqueVariant() after cart update...");
  //       //     this.changeUniqueVariant();
  //       // }, 1000); 
  //       // }
  //     },
  //     (error) => {
  //       console.error("❌ Error fetching cart:", error);
        
  //       this.loaded3 = true;
  //     }
  //   );
  // }
   


 selectAccessories(type: string, isChecked: boolean) {
      if (type === 'protectioncover') {
        this.addedProtectionCover = isChecked;
    
        const productId = 'ol_pc';
    
        if (isChecked) {
          this.addToCart('ol_pc');
        } else {
          if (this.cart && this.cart.products && this.cart.products.length > 0) {
            
            
                this.decreaseQuantityById('ol_pc');
                
              
            
          }
        }
      }
}


 addToCart(product: any) {
  const productId = typeof product === 'string' ? product : product.productId;

  if (!productId) {
    console.error('Product ID is missing');
    return;
  }

  $("#_page").css('pointer-events', 'none');
  this.loaded3 = false;
  this.cdr.detectChanges(); // 👈 Important

  if (environment.MAGIC_CHECKOUT_ENABLED) {
    Utils.addToCartIfLandedFromQuickbuy(this.externalRouter);
    this._cookie.set('productId', productId);

    this.postCart.productId = productId;

    const cartId = this._cookie.get('cartId');

    this.getCartService.postCart(cartId, productId).pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe({
      next: (data) => {
        this.cart = data.body;
        this.cartItemsService.updateApprovalMessage(data);
        this.sharingService.updateApprovalMessage(data);

        let i = 0;
        while (i < data.body.products.length) {
          if (data.body.products[i].productId === productId) {
            this.productQuantities[productId] = data.body.products[i].quantity;
            break;
          }
          i++;
        }

        if (i === data.body.products.length) {
          this.productQuantities[productId] = 1;
        }

        this.cartItems = data.body.products.length;
        this.loaded3 = true;
        this.cdr.detectChanges(); 
      },
      error: (error) => {
        console.error("Error adding product to cart:", error);
        $("#_page").css('pointer-events', 'auto');
        this.loaded3 = true;
        this.cdr.detectChanges();
      },
      complete: () => {
        $("#_page").css('pointer-events', 'auto');
        this.loaded3 = true;
        this.cdr.detectChanges();
      }
    });
  } else {
    Utils.checkOutInMobile(productId, this.authService, this.cookieService, this.externalRouter);
    $("#_page").css('pointer-events', 'auto');
    this.loaded3 = true;
    this.cdr.detectChanges();
  }
}

    
    
    couponDiscount = 0;
    grandTotal = 0;
    items: number;
    // removeFromCart(cartProductId: string) {
    //   $("#_page").css('pointer-events', 'none');
    //   this.loaded3 = false;
    
    //   this.getProductService.removeProduct(cartProductId).pipe(
    //     debounceTime(500),
    //     distinctUntilChanged()
    //   ).subscribe({
    //     next: (data) => {
    //       this.cartItemService.updateApprovalMessage(data);
    
    //       if (data.body == null) {
    //         // Cart is empty
    //         this.mrp = 0;
    //         this.discount = 0;
    //         this.total = 0;
    //         this.couponDiscount = 0;
    //         this.grandTotal = 0;
    //         this.items = 0;
    //         this._cookie.delete('cartId');
    //         // this.isCartEmpty.isRemove();
    //       } else {
    //         // Update cart
    //         // if (data.body.fastDeliveryApplied) {
    //         //   this.deliveryCharge = data.body.deliveryCharge;
    //         //   this.lightening = true;
    //         // }
    
    //         this.cart = data.body;
    //         this.items = data.body.products.length;
    //         this.mrp = data.body.mrpValue;
    //         this.discount = data.body.discountValue;
    //         this.total = data.body.offeredValue;
    //         this.couponDiscount = data.body.couponValue;
    //         this.grandTotal = data.body.cartFinalValue;
    //       }
    
    //       setTimeout(() => {
    //         $("#_page").css('pointer-events', 'auto');
    //         this.loaded3 = true;
    //       }, 300);
    //     },
    //     error: (error) => {
    //       console.error('Error removing product from cart:', error);
    //       $("#_page").css('pointer-events', 'auto');
    //       this.loaded3= true;
    //     }
    //   });
    // }


    
decreaseQuantityById(productId: string) {
    $("#_page").css('pointer-events', 'none');
    this.loaded3 = false;
    this.cdr.detectChanges(); 
      // Decrease local quantity
      if (this.productQuantities[productId]) {
        this.productQuantities[productId]--;
      }
  
      // If quantity reaches 0, remove the product from the cart
      if (this.productQuantities[productId] === 0) {
        let cartProductId: string | undefined;
  
        // Find the corresponding cartProductId from cart.products
        for (let i = 0; i < this.cart.products.length; i++) {
          const cartProduct = this.cart.products[i];
          if (cartProduct.product.productId == productId) {
            cartProductId = cartProduct.cartProductId;
            break;
          }
        }
  
        if (!cartProductId) {
          console.error("Cart Product ID not found.");
          $("#_page").css('pointer-events', 'auto');
          this.loaded3 = true;
          this.cdr.detectChanges(); 
          return;
        }
  
        // Call API to remove the product
        this.getProductService.removeProduct(cartProductId).pipe(debounceTime(500), distinctUntilChanged()).subscribe({
          next: (data) => {
            this.cartItemService.updateApprovalMessage(data);
  
            if (data.body == null) {
              // Cart is empty
              this.mrp = 0;
              this.discount = 0;
              this.total = 0;
              this.couponDiscount = 0;
              this.grandTotal = 0;
              this.items = 0;
              this._cookie.delete('cartId');
              // this.isCartEmpty.isRemove();
            } else {
              // Update cart
              // if (data.body.fastDeliveryApplied) {
              //   this.deliveryCharge = data.body.deliveryCharge;
              //   this.lightening = true;
              // }
  
              this.cart = data.body;
              this.items = data.body.products.length;
              this.mrp = data.body.mrpValue;
              this.discount = data.body.discountValue;
              this.total = data.body.offeredValue;
              this.couponDiscount = data.body.couponValue;
              this.grandTotal = data.body.cartFinalValue;
            }
  
         
              $("#_page").css('pointer-events', 'auto');
              this.loaded3 = true;
              this.cdr.detectChanges(); 
            
          },
          error: (error) => {
            console.error('Error removing product from cart:', error);
            $("#_page").css('pointer-events', 'auto');
            this.loaded3 = true;
            this.cdr.detectChanges(); 
          }
        });
      } else {
        // Quantity is still >= 1, just update the cart
        const updated = {
          cartId: this._cookie.get('cartId'),
          productId: productId,
          quantity: this.productQuantities[productId]
        };
  
        this.getCartService.updateCart(updated, this._cookie.get('Authorization')).pipe(debounceTime(500), distinctUntilChanged()).subscribe({
          next: (data) => {
            // if (data.body.coupon == null) {
            //   this.showCoupon = false;
            // }
  
            this.cartItemService.updateApprovalMessage(data);
  
           
  
            this.cart = data.body;
            this.items = data.body.products.length;
            this.mrp = data.body.mrpValue;
            this.discount = data.body.discountValue;
            this.total = data.body.offeredValue;
            this.couponDiscount = data.body.couponValue;
            this.grandTotal = data.body.cartFinalValue;
  
            $("#_page").css('pointer-events', 'auto');
            this.loaded3 = true;
            this.cdr.detectChanges(); 
          },
          error: (error) => {
            console.error('Error updating cart:', error);
            $("#_page").css('pointer-events', 'auto');
            this.loaded3= true;
            this.cdr.detectChanges(); 
          }
        });
      }
  }



}
